const IDC = ( state = {} ) => {
	return state;
};

export default IDC;
